import React from 'react';
import { Button } from '../../styles/components';

const PrimaryButton = ({ children, ...props }) => {
  return (
    <Button {...props}>
      {children}
    </Button>
  );
};

export default PrimaryButton; 